import scrollMonitor from 'scrollmonitor';
import classnameToggle from './../../scripts/classname-toggle';

let watcher;
const wrapper = document.querySelector('[data-component="careers-positions"]');
const sidebar = document.querySelector('[data-careers-departments-list]');

function visibilityChecker() {
  classnameToggle(sidebar, 'is-sticky', watcher.isFullyInViewport);
  classnameToggle(sidebar, 'is-bottom-positioned', watcher.isAboveViewport);
}

if (wrapper && sidebar) {
  watcher = scrollMonitor.create(wrapper);

  watcher.stateChange(visibilityChecker);
  visibilityChecker();
}
